import { apiClient, Auth } from '@/shared/api'

export const getGuestPaymentEligibility = async (contractId: number) => {
  await apiClient.get<null>({
    endpoint: `/guest/contracts/${contractId}/payment-eligibility`,
    auth: Auth.REQUIRED,
  })

  return null
}
